import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { injectIntl } from 'react-intl';
import Form from 'react-bootstrap/Form';
import FormGroup from 'react-bootstrap/FormGroup';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../../Common/Loader/Loader';
import PlaceGeoSuggest from '../../Common/PlaceGeoSuggest/PlaceGeoSuggest';
import InputFieldComponent from '../../Common/InputFieldComponent/InputFieldComponent';

import submit from './submit';
import validate from './validate';
import messages from '../../../locale/messages';

import bt from '../../commonStyle.css';



function RegisterForm(props) {
    const {
        handleSubmit,
        error,
        loading,
        intl: { formatMessage },
        phoneNumber,
        phoneDialCode,
        phoneCountryCode,
        preferredLanguage,
        referUrl,
        change
    } = props;

    useEffect(() => {
        if (referUrl) {
            change('referUrl', referUrl);
        }
    }, []);

    const handleSelectSuggest = useCallback(async (name, data, value) => {
        let city, state, country, zipcode;

        await change(name, data || '');

        if (data) {
            data?.addressComponents?.forEach((item) => {
                if (item?.types[0] === "country") {
                    country = item?.longText;
                } else if (item?.types[0] === "postal_code") {
                    zipcode = item?.shortText;
                } else if (item?.types[0] === 'administrative_area_level_3') {
                    city = item?.longText;
                } else if (item?.types[0] === 'administrative_area_level_1') {
                    state = item?.longText;
                }
            });

            await Promise.all([
                change('lat', data?.location?.latitude),
                change('lng', data?.location?.longitude),
                change('city', city),
                change('state', state),
                change('country', country),
                change('zipcode', zipcode),
                change('address', value),
                change('preferredLocation', value),
                change('preferredLat', data?.location?.latitude),
                change('preferredLng', data?.location?.longitude),
                change('phoneNumber', phoneNumber),
                change('phoneCountryCode', phoneCountryCode),
                change('phoneDialCode', phoneDialCode),
                change('preferredLanguage', preferredLanguage),
            ]);
        }

    }, []);

    const renderPlacesSuggest = useCallback(({ input, id, label, meta: { touched, error }, initialValue, disabled, placeholder, autoFocus }) => {

        return (
            <FormGroup className={cx(bt.space0)}>
                <label className={bt.commonLabelText}>{label}<sup className={bt.errorMessage}>*</sup></label>
                <PlaceGeoSuggest
                    {...input}
                    label={label}
                    placeholder={placeholder}
                    handleSelectSuggest={(data, value) => handleSelectSuggest(input.name, data, value)}
                    disabled={disabled}
                    initialValue={initialValue}
                    id={id}
                    autoFocus={autoFocus}
                    inputClass={cx(bt.formControlInput, 'form-control')}
                />
                {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
            </FormGroup>
        );
    }, [formatMessage]);

    return (
        <form onSubmit={handleSubmit(submit)}>
            {error && <span>{formatMessage(error)}</span>}
            <div className='oneColumnGrid'>
                <Field
                    name="firstName"
                    type="text"
                    component={InputFieldComponent}
                    label={formatMessage(messages.firstNameText)}
                    placeholder={formatMessage(messages.firstNameText)}
                    maxlength={20}
                    inputClass={bt.formControlInput}
                />
                <Field
                    name="lastName"
                    type="text"
                    component={InputFieldComponent}
                    label={formatMessage(messages.lastNameText)}
                    placeholder={formatMessage(messages.lastNameText)}
                    maxlength={20}
                    inputClass={bt.formControlInput}
                />
                <Field
                    name="email"
                    type="text"
                    component={InputFieldComponent}
                    label={formatMessage(messages.emailText)}
                    placeholder={formatMessage(messages.emailText)}
                    inputClass={bt.formControlInput}
                />
                <Field
                    name="location"
                    component={renderPlacesSuggest}
                    label={formatMessage(messages.locationName)}
                    placeholder={formatMessage(messages.locationName)}
                    disabled={false}
                    autoComplete="off"
                    autoFocus
                />
            </div>
            <div className={cx('buttonGroupContainer', 'buttonGroupDivider')}>
                <Loader
                    type={"button"}
                    buttonType={'submit'}
                    show={loading}
                    label={formatMessage(messages.finishText)}
                    className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                />
            </div>
        </form>
    );
}

RegisterForm = reduxForm({
    form: 'RegisterForm',
    validate,
    onSubmit: submit
})(RegisterForm);

const loginSelector = formValueSelector('LoginForm');

const mapState = state => ({
    loading: state.loader.registerLoading,
    phoneNumber: loginSelector(state, 'phoneNumber'),
    phoneDialCode: loginSelector(state, 'phoneDialCode'),
    phoneCountryCode: loginSelector(state, 'phoneCountryCode'),
    preferredLanguage: state.runtime.availableLocales[0],
    referUrl: loginSelector(state, 'referUrl'),
});

export default injectIntl(withStyles(bt)(connect(mapState, null)(RegisterForm)));

